import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const maintenanceInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 503 &&
        error.error?.code === 'MAINTENANCE_MODE'
      ) {
        void router.navigateByUrl('/maintenance');
      }
      return throwError(() => error);
    }),
  );
};
